import styles from "@/components/ChartSwitcher.module.css";

interface ChartSwitcherOption<Key extends string> {
  key: Key;
  label: string;
}

interface ChartSwitcherProps<Key extends string> {
  // Names the group for assistive tech ("Chart type", "Rows shown", …).
  label: string;
  options: readonly ChartSwitcherOption<Key>[];
  value: Key;
  onChange: (key: Key) => void;
}

const ChartSwitcher = <Key extends string>({
  label: groupLabel,
  options,
  value,
  onChange,
}: ChartSwitcherProps<Key>) => (
  <div aria-label={groupLabel} className={styles.rail} role="group">
    {options.map(({ key, label }) => (
      <button
        key={key}
        aria-pressed={key === value}
        className={
          key === value ? `${styles.button} ${styles.active}` : styles.button
        }
        type="button"
        onClick={() => onChange(key)}
      >
        {label}
      </button>
    ))}
  </div>
);

export default ChartSwitcher;
